import type { Role } from '@gl/shared';
import {
  ChartColumn,
  CircleEllipsis,
  CreditCard,
  Globe,
  House,
  Palette,
  ReceiptText,
  Settings,
  Store,
  Tags,
  Users,
  UtensilsCrossed,
  Wallet,
  type LucideIcon,
} from 'lucide-react';

export interface NavItem {
  /** Ruta relativa a /l/:localId */
  to: string;
  label: string;
  icon: LucideIcon;
  /** Si se define, solo se muestra a estos roles. */
  roles?: Role[];
}

/** Sidebar de escritorio. */
export const SIDEBAR_NAV: NavItem[] = [
  { to: 'resumen', label: 'Resumen', icon: House },
  { to: 'caja', label: 'Caja', icon: Wallet },
  { to: 'caja/cierres', label: 'Cierres de caja', icon: ReceiptText, roles: ['OWNER', 'MANAGER'] },
  { to: 'menu', label: 'Menú', icon: UtensilsCrossed },
  { to: 'precios', label: 'Precios', icon: Tags, roles: ['OWNER', 'MANAGER'] },
  { to: 'estadisticas', label: 'Estadísticas', icon: ChartColumn, roles: ['OWNER', 'MANAGER'] },
  { to: 'configuracion', label: 'Configuración', icon: Settings },
];

/** Bottom tab bar en mobile: Caja / Menú / Stats / Más. */
export const BOTTOM_TABS: NavItem[] = [
  { to: 'caja', label: 'Caja', icon: Wallet },
  { to: 'menu', label: 'Menú', icon: UtensilsCrossed },
  { to: 'estadisticas', label: 'Stats', icon: ChartColumn },
  { to: 'mas', label: 'Más', icon: CircleEllipsis },
];

/** Secciones de Configuración. */
export const CONFIG_NAV: NavItem[] = [
  { to: 'configuracion/general', label: 'General', icon: Store },
  { to: 'configuracion/apariencia', label: 'Apariencia', icon: Palette, roles: ['OWNER', 'MANAGER'] },
  { to: 'configuracion/dominio', label: 'Dominio y QR', icon: Globe, roles: ['OWNER', 'MANAGER'] },
  { to: 'configuracion/equipo', label: 'Equipo', icon: Users, roles: ['OWNER'] },
  { to: 'configuracion/suscripcion', label: 'Suscripción', icon: CreditCard, roles: ['OWNER'] },
];

export function visibleFor(role: Role) {
  return (item: NavItem) => !item.roles || item.roles.includes(role);
}
